export default __webpack_public_path__ + "32bc9f862bc55ab55062b1e63552b8b7.png";